import {
  THREADS_RESET, THREADS_LIVE_STARTED, THREADS_LIVE_SNAPSHOT, THREADS_LIVE_ERROR,
  THREADS_OLDER_REQUEST, THREADS_OLDER_SUCCESS, THREADS_OLDER_FAILURE,
  THREADS_SET_HAS_MORE
} from "./ThreadsTypes";

const initial = {
  threadsDesc: [], loading: false, error: null,
  hasMoreOlder: true, loadingOlder: false, oldestCursor: null
};
const dedupe = (a,b) => {
  const seen = new Set(a.map(x=>x.id)); const out = [...a];
  for (const t of b) if (!seen.has(t.id)) { out.push(t); seen.add(t.id); }
  return out;
};
export const threadsReducer = (state = initial, action) => {
  switch (action.type) {
    case THREADS_RESET: return { ...initial };
    case THREADS_LIVE_STARTED: return { ...state, loading: true, error: null };
    case THREADS_LIVE_SNAPSHOT: {
      const live = action.payload?.docsDesc || [];
      const older = state.threadsDesc.filter(x => !live.find(y => y.id === x.id));
      const m = [...live, ...older];
      const oldest = m[m.length - 1]?._snapRef || null;
      return { ...state, loading:false, threadsDesc: m, oldestCursor: oldest };
    }
    case THREADS_LIVE_ERROR: return { ...state, loading:false, error: action.payload };
    case THREADS_OLDER_REQUEST: return { ...state, loadingOlder:true, error:null };
    case THREADS_OLDER_SUCCESS: {
      const merged = dedupe(state.threadsDesc, action.payload || []);
      const oldest = merged[merged.length - 1]?._snapRef || state.oldestCursor;
      return { ...state, loadingOlder:false, threadsDesc: merged, oldestCursor: oldest };
    }
    case THREADS_OLDER_FAILURE: return { ...state, loadingOlder:false, error: action.payload };
    case THREADS_SET_HAS_MORE: return { ...state, hasMoreOlder: !!action.payload };
    default: return state;
  }
};
